import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Check, Clock, Download, CreditCard, RefreshCw } from 'lucide-react';
const PRICING_OPTIONS = [{
  id: 'grado1',
  emoji: '📘',
  title: '1º GRADO',
  desc: 'Reconocimiento de letras y fluidez básica. 32 lecturas + 32 fichas de actividades.',
  oldPrice: '$18.900',
  newPrice: '$12.990',
  isPopular: false,
  checkoutUrl: 'https://lectoracheck.meegapack.com/cart/46051212394684:1'
}, {
  id: 'grado2',
  emoji: '📘',
  title: '2º GRADO',
  desc: 'Comprensión de tramas y vocabulario. 32 lecturas + 32 fichas de actividades.',
  oldPrice: '$18.900',
  newPrice: '$12.990',
  isPopular: false,
  checkoutUrl: 'https://lectoracheck.meegapack.com/cart/46051215179964:1'
}, {
  id: 'grado3',
  emoji: '📘',
  title: '3º GRADO',
  desc: 'Comprensión inferencial e inicio de análisis. 32 lecturas + 32 fichas de actividades.',
  oldPrice: '$18.900',
  newPrice: '$12.990',
  isPopular: false,
  checkoutUrl: 'https://lectoracheck.meegapack.com/cart/46051215933628:1'
}, {
  id: 'grado4',
  emoji: '📘',
  title: '4º GRADO',
  desc: 'Textos expositivos, leyendas y noticias. 32 lecturas + 32 fichas de actividades.',
  oldPrice: '$18.900',
  newPrice: '$12.990',
  isPopular: false,
  checkoutUrl: 'https://lectoracheck.meegapack.com/cart/46051217440956:1'
}, {
  id: 'grado5',
  emoji: '📘',
  title: '5º GRADO',
  desc: 'Argumentación y reflexión ciudadana. 32 lecturas + 32 fichas de actividades.',
  oldPrice: '$18.900',
  newPrice: '$12.990',
  isPopular: false,
  checkoutUrl: 'https://lectoracheck.meegapack.com/cart/46051218129084:1'
}, {
  id: 'grado6',
  emoji: '📘',
  title: '6º GRADO',
  desc: 'Pensamiento crítico y análisis profundo. 32 lecturas + 32 fichas de actividades.',
  oldPrice: '$18.900',
  newPrice: '$12.990',
  isPopular: false,
  checkoutUrl: 'https://lectoracheck.meegapack.com/cart/46051218620604:1'
}, {
  id: 'completa',
  emoji: '🏆',
  title: 'PRIMARIA COMPLETA (1º A 6º)',
  desc: 'Los 6 grados + los 3 bonos + Plan Lector Anual',
  oldPrice: '$48.600',
  newPrice: '$19.990',
  isPopular: true,
  checkoutUrl: 'https://lectoracheck.meegapack.com/cart/46045651927228:1'
}];
const SUMMARY_INDIVIDUAL = ['32 lecturas narrativas', '32 fichas de actividades', 'Progresión semanal marzo a diciembre', 'Banco de consignas inteligentes', 'Kit de emergencia', 'El Escudo Escolar'];
const SUMMARY_COMPLETA = ['192 lecturas narrativas listas para imprimir (1º a 6º)', '192 fichas de actividades de comprensión', 'Plan lector anual semana a semana', '6 carpetas digitales organizadas por grado', 'Banco de 150 consignas inteligentes', 'Kit de emergencia con 58 herramientas', 'Sistema de seguimiento para padres y directivos'];
export function PricingSection() {
  // Countdown timer logic (2 hours)
  const [timeLeft, setTimeLeft] = useState(7200);
  const [selectedId, setSelectedId] = useState('completa');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  const selectedOption = PRICING_OPTIONS.find(opt => opt.id === selectedId) || PRICING_OPTIONS[6];
  const isCompleta = selectedId === 'completa';
  const currentSummary = isCompleta ? SUMMARY_COMPLETA : SUMMARY_INDIVIDUAL;
  return <section id="compra" className="py-24 bg-[#1E3A5F] relative scroll-mt-10" data-id="element-278">
      <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-279"></div>

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-280">
        <div className="text-center mb-12" data-id="element-281">
          <div className="inline-flex items-center bg-red-600 text-white px-6 py-2 rounded-full font-bold text-lg mb-8 shadow-lg animate-pulse" data-id="element-282">
            <Clock className="w-5 h-5 mr-2" data-id="element-283" />
            ESTA OFERTA EXPIRA EN: {formatTime(timeLeft)}
          </div>

          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-284">
            Elegí tu Mega Pack Aprendizaje Lectura:
          </h2>
          <p className="text-xl text-amber-300 font-medium" data-id="element-285">
            Todas las opciones incluyen los 3 bonos estratégicos
          </p>
        </div>

        <div className="max-w-2xl mx-auto mb-10 space-y-4" data-id="element-286">
          {PRICING_OPTIONS.map(opt => {
          const isSelected = selectedId === opt.id;
          return <div key={opt.id} onClick={() => setSelectedId(opt.id)} className={`relative flex items-start sm:items-center p-5 rounded-2xl cursor-pointer transition-all duration-200 ${isSelected ? 'border-2 border-[#F59E0B] bg-[#F59E0B]/10 shadow-[0_0_20px_rgba(245,158,11,0.2)]' : 'border border-white/20 bg-white/5 hover:bg-white/10'}`} data-id="element-287">
                {/* Radio Circle */}
                <div className="mt-1 sm:mt-0 mr-4 flex-shrink-0" data-id="element-288">
                  <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-[#F59E0B]' : 'border-white/50'}`} data-id="element-289">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-[#F59E0B]" data-id="element-290" />}
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-291">
                  <div className="flex-1" data-id="element-292">
                    <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-293">
                      <span className="text-white font-bold text-lg" data-id="element-294">
                        {opt.emoji} {opt.title}
                      </span>
                      {opt.isPopular && <span className="bg-[#F59E0B] text-white text-[10px] sm:text-xs font-black px-2 py-0.5 rounded-full uppercase tracking-wider" data-id="element-295">
                          MÁS ELEGIDO
                        </span>}
                    </div>
                    <p className="text-slate-300 text-sm leading-snug pr-2" data-id="element-296">
                      {opt.desc}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-left sm:text-right flex-shrink-0" data-id="element-297">
                    <p className="text-slate-400 line-through text-sm font-medium" data-id="element-298">
                      {opt.oldPrice}
                    </p>
                    <p className="text-white font-black text-2xl" data-id="element-299">
                      {opt.newPrice}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="max-w-2xl mx-auto mb-16 text-center" data-id="element-300">
          <Button href={selectedOption.checkoutUrl} variant="primary" size="xl" fullWidth className="shadow-xl shadow-green-500/30 text-lg md:text-xl py-4" data-id="element-301">
            SÍ, QUIERO {selectedOption.title} →
          </Button>
          <p className="text-slate-400 italic mt-4" data-id="element-302">
            Podés sumar otro grado cuando quieras
          </p>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-16 text-white" data-id="element-303">
          <div className="flex items-center" data-id="element-304">
            <CreditCard className="w-5 h-5 mr-2 text-amber-400" data-id="element-305" /> ✔ Pago único
          </div>
          <div className="flex items-center" data-id="element-306">
            <Clock className="w-5 h-5 mr-2 text-amber-400" data-id="element-307" /> ✔ Acceso
            inmediato
          </div>
          <div className="flex items-center" data-id="element-308">
            <Download className="w-5 h-5 mr-2 text-amber-400" data-id="element-309" /> ✔ Descarga
            ilimitada
          </div>
          <div className="flex items-center" data-id="element-310">
            <RefreshCw className="w-5 h-5 mr-2 text-amber-400" data-id="element-311" /> ✔ Sin
            suscripciones
          </div>
        </div>

        {/* What's included summary */}
        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl p-8 md:p-12 max-w-3xl mx-auto" data-id="element-312">
          <h4 className="text-2xl font-bold text-white mb-6 text-center uppercase" data-id="element-313">
            {isCompleta ? 'EL MEGA PACK COMPLETO INCLUYE:' : `${selectedOption.title} INCLUYE:`}
          </h4>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-314">
            {currentSummary.map((item, i) => <li key={i} className="flex items-start text-blue-50" data-id="element-315">
                <Check className="w-6 h-6 text-[#16A34A] mr-3 flex-shrink-0 bg-white rounded-full p-1" data-id="element-316" />
                <span className="font-medium" data-id="element-317">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}